import Link from 'next/link';
import { Layout, CtaForm } from '../../components';
import ReactPlayer from 'react-player';
import { FeatureIcon } from '../../components/Svg';
import { FEATURES } from '../../data/features';
import { omitKeyObject } from '../../utils';

export default function Feature({ feature }) {
	const {
		heading: { title, description },
		video_url,
		articles,
		plan,
		footer,
	} = feature;

	return (
		<Layout pageName={title}>
			<div className="feature">
				<section className="heading-container">
					<div className="container">
						<div className="heading">
							<h1 className="heading__title">{title}</h1>
							<h2 className="heading__desc">{description}</h2>
						</div>
					</div>
				</section>

				{video_url && (
					<section className="feature-video">
						<div className="container">
							<div className="player-wrapper">
								<ReactPlayer className="react-player" url={video_url} width="100%" height="100%" />
							</div>
						</div>
					</section>
				)}

				{articles && (
					<section className="feature-articles">
						<div className="container">
							<div className="feature-articles__wrapper">
								{articles.map(({ title, description, icon }, index) => {
									return (
										<article
											key={index}
											className={`feature-article ${articles.length == 2 && 'feature-article--w50'}`}
										>
											<div className="feature-article__icon">{FeatureIcon(icon)}</div>
											<h3 className="feature-article__title">{title}</h3>
											<div
												className="feature-article__desc"
												dangerouslySetInnerHTML={{
													__html: description,
												}}
											></div>
										</article>
									);
								})}
							</div>
						</div>
					</section>
				)}

				<div className="pricing-wrapper">
					<div className="container">
						<h2
							className="pricing-wrapper__title"
							dangerouslySetInnerHTML={{
								__html: plan,
							}}
						></h2>

						<button className="btn btn--plans">
							<Link href="/pricing-plans">view plans and pricing</Link>
						</button>
					</div>
				</div>

				<CtaForm title={footer} />
			</div>
		</Layout>
	);
}

export async function getStaticProps({ params }) {
	try {
		const feature = FEATURES.map((item) => omitKeyObject('submenu', item)).find(({ slug }) => slug == params.slug);

		return {
			props: {
				feature,
			},
		};
	} catch (err) {
		return {
			notFound: true,
		};
	}
}

export async function getStaticPaths() {
	const paths = FEATURES.map((feature) => omitKeyObject('submenu', feature)).map(({ slug }) => `/features/${slug}`);

	return {
		paths: paths,
		fallback: false,
	};
}
